/* eslint-disable camelcase */
import ABCyaPhaser from '@abcya/abcya_phaser';
import GameScreen from './scenes/GameScreen';
import IntroScreen from './scenes/IntroScreen';
import LevelScreen from './scenes/LevelScreen';

export default {
  /**
     * Add your scene classes here. Simply put the scene class.
     * Ex: `scenes: [MyScene,MyOtherScene]`
     * @type {{KEY:string}[]}
     */
  scenes: [IntroScreen, LevelScreen, GameScreen],

  /**
     * Set the first scene that should be loaded here. Must match one of the scenes' key found in the scenes array.
     * It is recommended you put `MyScene.KEY` here instead of using a string.
     * @type {string}
     */
  startScene: IntroScreen.KEY,

  MUSIC_ON: true,
  INSTRUCTIONS_SEEN: false,
  WIN_SEEN: false,
  currentLevel: null, // set to one of the levels below
  variantLevelIndex: 0, // this is used in variants, to keep track of which level it is

  levels: {
    buggy_cuppy:
    {
      words: ['SEVEN', 'WATER', 'CUP', 'TABLE', 'PEN', 'FLOWER', 'APPLE', 'SIGN', 'SHIRT', 'BOY'],
      btnImage: 'BTN_buggy_cuppy',
      name: 'Buggy Cuppy',
      levelImage: 'buggy_cuppy',
      colors: [0x22f4b3, 0x017753],
      positioning: [0,0],
      isCompleted: false,
      imageAtlas: ABCyaPhaser.Images.DEFAULT_ATLAS,
      wordPositions: [
        [[580, 420, 150, 280]],
        [[210, 210, 420, 330]],
        [[180, 270, 440, 520]],
        [[440, 385, 100, 80]],
        [[315, 250, 50, 200]],
        [[660, 150, 80, 80]],
        [[480, 50, 70, 60]],
        [[450, 490, 110, 90]],
        [[145, 430, 60, 60]],
        [[50, 10, 760, 800]]
      ]
    },
    birthday_bash:
    {
      words: ['ONE', 'RADIO', 'MEAT', 'CHEST', 'BUS', 'PANTS', 'TOY', 'DESK', 'CEREAL', 'PLANE'],
      btnImage: 'BTN_birthday_bash',
      name: 'Birthday Bash',
      levelImage: 'birthday_bash',
      colors: [0xc2dd3c, 0x017753],
      positioning: [-15,0],
      isCompleted: false,
      imageAtlas: ABCyaPhaser.Images.DEFAULT_ATLAS,
      wordPositions: [
        [[436,25,60,150]],
        [[615,660,140,100]],
        [[602, 13, 138, 150]],
        [[51, 508, 351,208]],
        [[80,69, 259, 161]],
        [[469,228, 249, 226]],
        [[10,616,138,267]],
        [[544, 735, 220, 100]],
        [[93, 698, 196, 107]],
        [[13, 422, 449, 154]]
      ]
    },
    party_ride:
    {
      words: ['CARROT', 'THREE', 'FORK', 'BUSH', 'NEWSPAPER', 'FRUIT', 'BIRD', 'CLOUD', 'ROCK', 'RABBIT'],
      btnImage: 'BTN_party_ride',
      name: 'Party Ride',
      levelImage: 'party_ride',
      colors: [0x5fa82f, 0x1b4202],
      positioning: [-46,70],
      isCompleted: false,
      imageAtlas: ABCyaPhaser.Images.DEFAULT_ATLAS,
      wordPositions: [
        [[476, 34.5, 95, 96]],
        [[625, 380, 109, 186]],
        [[360, 78, 181, 55]],
        [[592,586,166,124]],
        [[617, 37, 112, 83]],
        [[552, 602, 77,70]],
        [[330,285,164,152]],
        [[464,245,299,162]],
        [[614,645,105,115]],
        [[489,402,98,186]]
      ]
    },
    check_up:
    {
      words: ['COMPUTER', 'MOVIE', 'BOOK', 'NURSE', 'GIRL', 'TWO', 'EIGHT', 'TV', 'DOCTOR', 'BALLGAME'],
      btnImage: 'BTN_check_up',
      name: 'Check Up',
      levelImage: 'check_up',
      colors: [0x2fe0d7, 0x107572],
      positioning: [-30,-25],
      isCompleted: false,
      imageAtlas: ABCyaPhaser.Images.LOCALIZATION_ATLAS,
      wordPositions: [
        [[505,610,241,252]],
        [[529,642,167,118]],
        [[47,230,222,277]],
        [[363,11,392,402]],
        [[130,604,235,241]],
        [[630, 69, 33, 44]],
        [[65,470, 63, 68]],
        [[185,225,470,400]],
        [[119,52,323,180]],
        [[229,267,337,336]]
      ]
    },
    lake_friends:
    {
      words: ['FARMER', 'DUCK', 'PIG', 'BAND', 'HORSE', 'FIELD', 'TEN', 'MAGAZINE', 'DIRT', 'JUICE'],
      btnImage: 'BTN_lake_friends',
      name: 'Lake Friends',
      levelImage: 'lake_friends',
      colors: [0x43f7ad, 0x6969cc],
      positioning: [0,15],
      isCompleted: false,
      imageAtlas: ABCyaPhaser.Images.DEFAULT_ATLAS,
      wordPositions: [
        [[12,577,199,226]],
        [[617,449,134,79]],
        [[538,105,119,137]],
        [[3,224,173,193]],
        [[256,179,137,308]],
        [[0,713,355,192]],
        [[145,410,102,82]],
        [[202,279,87,67]],
        [[0,713,355,192]],
        [[588,572,131,167]]
      ]
    },
    lost_lunch:
    {
      words: ['TRAIN', 'DOLL', 'DOG', 'SPOON', 'CHICKEN', 'BALL', 'BREAD', 'ORANGE', 'CRAYON', 'MOON'],
      btnImage: 'BTN_lost_lunch',
      name: 'Lost Lunch',
      levelImage: 'lost_lunch',
      colors: [0xda8aff, 0x58388c],
      positioning: [-15,-20],
      isCompleted: false,
      imageAtlas: ABCyaPhaser.Images.DEFAULT_ATLAS,
      wordPositions: [
        [[307,451,266,132]],
        [[560, 478,142,219]],
        [[91,112,307,413]],
        [[68,490,50,225]],
        [[420,138,330,239]],
        [[244, 394, 166, 216], [384,264,58,109], [448, 300, 58, 97], [544, 331, 70, 80], [625, 326, 59, 59]],
        [[353, 62, 385, 180]],
        [[329,613,151,138]],
        [[300,137,139,129]],
        [[185,544,85,83]]
      ]
    },
    cow_tour:
    {
      words: ['LETTER', 'DRESS', 'CHALK', 'TRUCK', 'NINE', 'POLICE', 'HAT', 'BANANA', 'BIRD', 'STAR'],
      btnImage: 'BTN_cow_tour',
      name: 'Cow Tour',
      levelImage: 'cow_tour',
      colors: [0xf4ca4c, 0x731f12],
      positioning: [0,-30],
      isCompleted: false,
      imageAtlas: ABCyaPhaser.Images.DEFAULT_ATLAS,
      wordPositions: [
        [[526, 138, 83,112]],
        [[220,208,160,115]],
        [[15,171,110,100]],
        [[14,698,298,121]],
        [[93,378,133,181]],
        [[454,519,132,179]],
        [[553,58,100,102], [460, 515, 89, 67]],
        [[598,552,152,107]],
        [[353,304,198,117]],
        [[67,721,87,73]]
      ]
    },
    queenly_home:
    {
      words: ['WOMAN', 'SOFA', 'TEA', 'GRASS', 'LAKE', 'MAN', 'BOAT', 'SOUP', 'GRAPE', 'PLANT'],
      btnImage: 'BTN_queenly_home',
      name: 'Queenly Home',
      levelImage: 'queenly_home',
      colors: [0xffb845, 0x8c4720],
      positioning: [0,-20],
      isCompleted: false,
      imageAtlas: ABCyaPhaser.Images.DEFAULT_ATLAS,
      wordPositions: [
        [[174,406,192,180]],
        [[470,703,121,148]],
        [[178,188,196,112]],
        [[588,726,139,134], [4, 778, 95, 51]],
        [[202,601,286,244]],
        [[531,31,184,204]],
        [[261,711,56,56]],
        [[381,457,110,127]],
        [[648,352,91,143]],
        [[7,496,169,329]]
      ]
    },
    breakfast:
    {
      words: ['FISH', 'BOAT', 'HILL', 'CAT', 'MILK', 'BOOK', 'TREE', 'SUN', 'SIX', 'PENCIL'],
      btnImage: 'BTN_breakfast',
      name: 'Breakfast',
      levelImage: 'breakfast',
      colors: [0xb060f8, 0x000000],
      positioning: [0,0],
      isCompleted: false,
      imageAtlas: ABCyaPhaser.Images.DEFAULT_ATLAS,
      wordPositions: [
        [[411,386,88, 134]],
        [[110,390,171,83]],
        [[114,218,211,176]],
        [[407,562,214,253]],
        [[266,1.5,501,515]],
        [[399,29,226,142]],
        [[25,486,202,329]],
        [[193,89,142,151]],
        [[556,302,89,76]],
        [[603,478,104,209]]
      ]
    },
    night_attic:
    {
      words: ['BABY', 'GAME', 'CAR', 'RAIN', 'PEAR', 'FIVE', 'CHAIR', 'BOWL', 'SODA', 'SHOE'],
      btnImage: 'BTN_night_attic',
      name: 'Night Attic',
      levelImage: 'night_attic',
      colors: [0x7c6eff, 0x1f0c8e],
      positioning: [0,0],
      isCompleted: false,
      imageAtlas: ABCyaPhaser.Images.DEFAULT_ATLAS,
      wordPositions: [
        [[529,633,184,221]],
        [[286,742,251,131]],
        [[401,15,183,90]],
        [[576,63,191,133]],
        [[302,66,73,95]],
        [[658,616,87,122]],
        [[155,21,127,183]],
        [[539,363,192,51]],
        [[79,255,98,146]],
        [[607,438, 146, 163]]
      ]
    }
  }
};